var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],staticClass:"letter",attrs:{"id":"letter"},domProps:{"innerHTML":_vm._s(_vm.admissionLetter)}})
}
var staticRenderFns = []

export { render, staticRenderFns }